
import {defineComponent } from 'vue';
export default defineComponent({
    name: 'customizeView',
    inheritAttrs: false,
    props: {
      estimateAmount:{
        type: Number,
        required: false,
      },
      promotionAmount:{
        type: Number,
        required: false,
      },
        totalAmount:{
            type: Number,
            required: false,
        },
    },
});
